import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import RebrandRedirect from './_components/ui/RebrandRedirect.tsx'
import './index.css'

// v3nture.studio has become blanche.vc. The old HomePage is intentionally no
// longer mounted: every visit shows the blocking rebrand interstitial and is
// forwarded to https://blanche.vc/ (see SEO-STRATEGY.md for the migration plan).
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RebrandRedirect />
  </StrictMode>,
)
